import { GetStaticProps, GetStaticPaths } from 'next';
import { getAllPostContents, getRedirectPaths } from '@api';

import { PostPage } from '@components';
import { getStaticPropsCore } from '@/src/getStatic/getStaticPropsCore';

export const getStaticProps = async ({
  params,
}: Parameters<GetStaticProps<any, { slug: string; page: string }>>[0]) => {
  console.info(`getStaticProps /blog/${params?.slug}/${params?.page}`);
  return await getStaticPropsCore(params?.slug || '', {
    pageInPost: Number(params?.page),
  });
};

export const pathsFromPosts = (
  posts: {
    slug?: string | null | undefined;
    content?: string | null | undefined;
  }[]
) =>
  posts
    .map((post) => ({
      slug: post.slug,
      pageCount: (post.content?.match(/<!--nextpage-->/g) || []).length + 1,
    }))
    .filter(({ pageCount }) => pageCount > 1)
    .flatMap(({ slug, pageCount }) =>
      Array(pageCount)
        .fill(0)
        .map((_, i) => ({
          params: { page: `${i + 1}`, slug: slug || 'INVALID' },
        }))
    );

export const getStaticPaths: GetStaticPaths<{
  slug: string;
  page: string;
}> = async () => {
  const redirects = await getRedirectPaths();
  const posts = await getAllPostContents({
    where: { search: 'nextpage', categoryNotIn: ['356'] },
  });

  return {
    paths: pathsFromPosts(posts).filter(
      (path) => !redirects.has(`/knowledge/blog/${path.params.slug}/`)
    ),
    fallback: 'blocking',
  };
};

export default PostPage;
